import React from "react";
import styles from "./ModalQuestionnary.module.scss";
import { SELLER } from "../../../../config/legal";

interface ModalQuestionnaryProps {
  isActive: boolean;
  setIsChecked: (value: boolean) => void;
  setIsActive: (value: boolean) => void;
}

const ModalQuestionnary: React.FC<ModalQuestionnaryProps> = ({ isActive, setIsChecked, setIsActive }) => {
  React.useEffect(() => {
    if (isActive) {
      document.body.classList.add("lock");
    } else {
      document.body.classList.remove("lock");
    }

    return () => {
      document.body.classList.remove("lock");
    };
  }, [isActive]);
  return (
    <>
      <div className={styles.modalTop}>
        <h3 className={styles.title}>Согласие на обработку персональных данных</h3>
      </div>
      <div className={styles.info}>
        <p>
          Настоящим в соответствии с Федеральным законом № 152-ФЗ «О персональных данных» от 27.07.2006 года свободно, своей волей
          и в своем интересе выражаю свое безусловное согласие на обработку моих персональных данных оператору — {SELLER.name}, ИНН{" "}
          {SELLER.inn}, ОГРНИП {SELLER.ogrnip}, адрес: {SELLER.address} (далее по тексту — Оператор).
        </p>
        <ul>
          <ol>
            1. Согласие дается на обработку одной, нескольких или всех категорий персональных данных, не являющихся специальными
            или биометрическими, предоставляемых мною, которые могут включать:
          </ol>
          <br />
          <ul>
            <li>- Имя;</li>
            <li>- Фамилия;</li>
            <li>- Телефон;</li>
            <li>- E-mail;</li>
            <li>- Ваш бренд;</li>
            <li>- Сайт;;</li>
            <li>- Социальные сети бренда;</li>
            <li>- Опишите ваш бизне;</li>
            <li>- Интересующие образцы тканей.;</li>
          </ul>
          <br />
          <ol>
            2. Оператор может совершать следующие действия: сбор; запись; систематизация; накопление; хранение; уточнение
            (обновление, изменение); извлечение; использование; блокирование; удаление; уничтожение.
          </ol>
          <br />
          <ol>3. Способы обработки: как с использованием средств автоматизации, так и без их использования.</ol>
          <br />
          <ol>
            4. Цель обработки: предоставление мне услуг/работ, включая, направление в мой адрес уведомлений, касающихся
            предоставляемых услуг/работ, подготовка и направление ответов на мои запросы, направление в мой адрес информации о
            мероприятиях/товарах/услугах/работах Оператора.
          </ol>
          <br />
          <ol>
            5. Оператор обрабатывает данные самостоятельно. Передача третьим лицам возможна только в объёме, нужном для исполнения
            заявки или заказа: службам доставки и связи, а при оплате — АО «ТБанк» на платёжном шлюзе банка.
          </ol>
          <br />
          <ol>
            6. Настоящее согласие действует до момента его отзыва путём письменного обращения по адресу: {SELLER.address}.
          </ol>
          <br />
          <ol>
            7. В случае отзыва мною согласия на обработку персональных данных Оператор вправе продолжить обработку персональных
            данных без моего согласия при наличии оснований, предусмотренных Федеральным законом №152-ФЗ «О персональных данных»
            от 27.07.2006 г.
          </ol>
        </ul>
      </div>
      <div className={styles.buttons}>
        <button
          className={styles.agree}
          onClick={() => {
            setIsActive(false);
            setIsChecked(true);
          }}
        >
          Принимаю
        </button>
        <button
          className={styles.cancel}
          onClick={() => {
            setIsActive(false);
            setIsChecked(false);
          }}
        >
          Не принимаю
        </button>
      </div>
    </>
  );
};

export default ModalQuestionnary;
